import React from 'react'
import { Box, Typography } from '@mui/material'
import { useIntl } from 'react-intl'
import type { StepHeadingProps } from '../types'

export const StepHeading: React.FC<StepHeadingProps> = ({ step, count }) => {
  const { formatMessage } = useIntl()

  return (
    <Box mb={3}>
      <Typography variant="h1" fontWeight={700} mb={1}>
        {formatMessage({ id: `connectOnlyFlowProvidersModal.step${step}.heading` }, step === 2 ? { count } : undefined)}
      </Typography>
      <Typography color="text.primary">
        {formatMessage({ id: `connectOnlyFlowProvidersModal.step${step}.subtext` }, { count })}
      </Typography>
    </Box>
  )
}
